import { flow, groupBy, map } from 'lodash/fp';
const pairMap = map.convert({ cap: false });

import { isTableType } from 'constants/chart-roles';
import { getMultiSeriesParentChannel } from 'utils/chart/multi-series-name';

/**
 * Turns all the columns into a series of column groups.
 * This is used to prevent moving columns being dragged to an invalid location
 * when dragging columns
 * @param {Object} stageData - The stage with the unprocessed spec
 * @returns {Object} - The processed stage spec with column groups
 */
function createColumnGroups(stageData) {
  const {
    spec,
    environment: { chartType },
  } = stageData;

  if (!isTableType(chartType)) {
    return {};
  }

  const groupedColumns = flow(
    groupBy(column =>
      column.field ? getMultiSeriesParentChannel(column.field) : column.groupId
    ),
    pairMap((value, key) => ({
      groupId: `${key}-group`,
      // column is already a column group
      ...(value.length === 1 && value[0].children ? value[0] : {}),
      // column is on its own and not a column group
      ...(value.length === 1 && !value[0].children
        ? { children: value, headerClass: 'hidden' }
        : {}),
      // group of multiseries columns, so put the array as the children
      ...(value.length > 1 ? { children: value, headerClass: 'hidden' } : {}),
      marryChildren: true,
    }))
  )(spec.columnDefs);

  const updatedSpec = {
    ...spec,
    columnDefs: groupedColumns,
    gridOptions: {
      ...spec.gridOptions,
      suppressDragLeaveHidesColumns: true,
    },
  };

  return { spec: updatedSpec };
}

export default {
  input: ['environment.chartType', 'spec'],
  fn: createColumnGroups,
};
export { createColumnGroups };
